import React, { memo } from 'react'

export default memo(function Title({ title,subTitle }) {
    return <h1 className='title'><span>{title}</span><span className='sub-title'>({subTitle})</span></h1>
})